// extracted by mini-css-extract-plugin
module.exports = {"mini":"Privacy_mini__3rmKn","link":"Privacy_link__2EllB","container":"Privacy_container__jFI-S","mobile":"Privacy_mobile__1lXvk"};